import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocI } from '../../core/interfaces/doc.interface';
import { DocSii } from 'app/common/models/docsii.model';
import { environment } from 'environments/environment';
import {
    BehaviorSubject,
    Observable,
    filter,
    map,
    catchError,
    of,
    switchMap,
    take,
    tap,
    throwError,
    interval,
    first,
    takeWhile,
    expand,
    reduce,
    EMPTY,
} from 'rxjs';
import { DocT, DocTFull } from '../../core/types/doc.type';
//import { DocI } from '../types/doc.type';
import { Pagination, PaginationApi } from '../../core/types/paginate.types';
import moment from 'moment';
import { consumerPollProducersForChange } from '@angular/core/primitives/signals';

export interface Data {
    acum: number;
    tota: number[];
    dias: string[];
}

export interface ResumenListadoDoc {
    cant: number;
    suma: number;
    dctm: number;
    afec: number;
    ivam: number;
    tota: number;
}

/** fin/edr: una fila del drill-down de celda (DocService.documentosPorCta). */
export interface DocPorCtaDetalle {
    id: number;
    tdoc: string;
    femi: string;
    nume: number;
    entidad: string | null;
    neto: number;
    iva: number;
    total: number;
}

export interface ListadoDoc {
    meta: PaginationApi;
    data: DocI[];
    resumen?: ResumenListadoDoc;
}

// Composición de saldo de un documento (FAP/FEP con NCP; para el resto de
// tipos totalNcp/cantNcp quedan en 0) — calculada por DocumentoSaldoService
// en el backend, expuesta como solo-lectura junto a GET /api/doc/pagos.
export interface ComposicionDocumento {
    id: number;
    kemp: number;
    kprv: number;
    tota: number;
    totalPagos: number;
    totalNcp: number;
    cantNcp: number;
    abon: number;
    saldo: number;
    stat: string;
    detalleEstado: string;
}

// Nota de Crédito Proveedor relacionada a un FAP/FEP (KEMP+KPRV+OLDT=TDOC+OLDN=NREF).
export interface NcpRelacionada {
    id: number;
    nref: string;
    femi: string;
    tota: number;
}

@Injectable({
    providedIn: 'root',
})
export class DocService {
    //Privates

    private _docsFull: BehaviorSubject<DocTFull[] | null> = new BehaviorSubject(
        null
    );
    private _docs: BehaviorSubject<DocI[] | null> = new BehaviorSubject(null);
    private _doc: BehaviorSubject<DocI | null> = new BehaviorSubject(null);
    private _pagination: BehaviorSubject<Pagination | null> =
        new BehaviorSubject(null);

    private _docsSii: BehaviorSubject<DocSii[] | null> = new BehaviorSubject(
        null
    );

    /* public getData(): Observable<DocI[]>{
          const urlApi =`${environment.urlApi}/api/doc`
          return this.http.get<DocI[]>(urlApi)
      }*/

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for Docs
     */
    get docs$(): Observable<DocI[]> {
        return this._docs.asObservable();
    }

    get docsSii$(): Observable<DocSii[]> {
        return this._docsSii.asObservable();
    }

    /**
     * Getter for Doc
     */
    get doc$(): Observable<DocI> {
        return this._doc.asObservable();
    }

    /**
     * Getter for pagination
     */
    get pagination$(): Observable<Pagination> {
        return this._pagination.asObservable();
    }

    getDocs(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = ''
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log(
            'getDocs> page,take,orderby,order,search: ',
            page,
            take,
            orderby,
            order,
            search
        );
        console.log(
            'params> page,take,orderby,order: ',
            page,
            take,
            orderby.split('.').length === 1 ? 'doc.' + orderby : orderby,
            order
        );
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/doc/list`,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'doc.' + orderby
                                : orderby,
                        order: order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    console.log(response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        page: parseInt(response.meta.page, 10),
                        lastPage: response.meta.pageCount,
                        startIndex: startIndex,
                        endIndex: endIndex,
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocs4Prv(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kprv: number = 0
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        /* console.log('environment.urlApi: ', environment.urlApi);
        console.log('orderby: ', orderby);
        console.log('orderby.split(.).length ', orderby.split('.')); */
        console.log('api:', `${environment.urlApi}/api/doc/list/` + kprv);
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/doc/list/` + kprv,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'doc.' + orderby
                                : orderby,
                        order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    console.log('getDocs4Prv>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        page: +response.meta.page - 1,
                        lastPage: response.meta.pageCount,
                        startIndex: 0, //startIndex,
                        endIndex: response.meta.itemCount, //endIndex
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsPending(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kprv: number = 0
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        /* console.log('environment.urlApi: ', environment.urlApi);
        console.log('orderby: ', orderby);
        console.log('orderby.split(.).length ', orderby.split('.')); */
        console.log(
            'api:',
            `${environment.urlApi}/api/doc/listPending/` + kprv
        );
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/doc/listPending/` + kprv,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'doc.' + orderby
                                : orderby,
                        order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    console.log('getDocs4Prv>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        page: +response.meta.page - 1,
                        lastPage: response.meta.pageCount,
                        startIndex: 0, //startIndex,
                        endIndex: response.meta.itemCount, //endIndex
                    });
                    this._docs.next(response.data);
                })
            );
    }

    /**
     * Contraparte ODS de getDocsPendingByCli() — apunta al endpoint
     * listOdsPendingByCli (backend: tdoc in ('ODS')), usado por ofv/cob.
     * No reutilizar getDocsPendingByCli() para ODS, ese está hardcoded a
     * tdoc in ('EFA','EFE').
     */
    getDocsOdsPendingByCli(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kcli: number = 0
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/doc/listOdsPendingByCli/` + kcli,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'doc.' + orderby
                                : orderby,
                        order,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex: (+response.meta.page - 1) * +response.meta.take,
                        endIndex: (+response.meta.page - 1) * +response.meta.take + +response.meta.take
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsPendingByCli(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kcli: number = 0
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        /* console.log('environment.urlApi: ', environment.urlApi);
        console.log('orderby: ', orderby);
        console.log('orderby.split(.).length ', orderby.split('.')); */
        console.log(
            'api:',
            `${environment.urlApi}/api/doc/listPendingByCli/` + kcli
        );
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/doc/listPendingByCli/` + kcli,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'doc.' + orderby
                                : orderby,
                        order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    console.log('getDocs4Prv>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        page: +response.meta.page - 1,
                        lastPage: response.meta.pageCount,
                        startIndex: 0, //startIndex,
                        endIndex: response.meta.itemCount, //endIndex
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsWithDocpagsByPrv(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kprv: number = 0
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> getDocsWithDocpagsByPrv()');
        const url = `${environment.urlApi}/api/doc/listWithDocpags/` + kprv;
        console.log('url', url);
        console.log('kprv: ', kprv);
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, {
                params: {
                    page: '' + page,
                    take: '' + take,
                    orderby:
                        orderby.split('.').length === 1
                            ? 'doc.' + orderby
                            : orderby,
                    order,
                    // search,
                },
            })
            .pipe(
                tap((response) => {
                    console.log('getDocs4Prv>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsWithDocpagsByCli(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kcli: number = 0
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        /* console.log('environment.urlApi: ', environment.urlApi);
        console.log('orderby: ', orderby);
        console.log('orderby.split(.).length ', orderby.split('.')); */
        console.log(
            'api:',
            `${environment.urlApi}/api/doc/listWithDocpags-cli/` + kcli
        );
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/doc/listWithDocpags-cli/` + kcli,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'doc.' + orderby
                                : orderby,
                        order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    console.log('listWithDocpags-cli>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsByKemp(kemp: number): Observable<DocTFull[]> {
        return this._httpClient
            .get<DocTFull[]>(`${environment.urlApi}/api/doc/vta/` + kemp)
            .pipe(
                tap((response) => {
                    console.log('---getDocsByKemp> response', response);

                    //this._docsFull.next(response.filter(doc => doc.kemp === kemp));
                    this._docsFull.next(response);
                })
            );
    }

    getDocById(id: number): Observable<DocI> {
        console.log('--> getDocById()');
        console.log('id', id);
        return this._docs.pipe(
            take(1),
            map((docs) => {
                //console.log('docs', docs)
                // Find the doc
                const doc = docs.find((item) => item.id === id) || null;
                //console.log('doc', doc)
                // Update the doc
                this._doc.next(doc);

                // Return the doc
                return doc;
            }),
            switchMap((doc) => {
                if (!doc) {
                    return throwError(
                        () =>
                            new Error(
                                'Could not found doc with id of ' + id + '!'
                            )
                    );
                }

                return of(doc);
            })
        );
    }

    /**
     * Create doc
     */
    createDoc(doc): Observable<DocI> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .post<DocI>(`${environment.urlApi}/api/doc`, doc)
                    .pipe(
                        map((newDoc) => {
                            console.log('newDoc', newDoc);
                            if (this._docs) {
                                // Update the docs with the new doc
                                const docsArray = docs || [];
                                //this._docs.next([newDoc, ...docs]);
                                this._docs.next([newDoc, ...docsArray]);
                            }

                            // Return the new doc
                            return newDoc;
                        })
                    )
            )
        );
    }

    /**
     * Update quirúrgico de solo Concepto de Flujo de Caja (kfco) y Centro de
     * Costo (kcco) — usado por el botón dedicado en modales de solo lectura
     * (FAP, etc.) donde el resto del formulario permanece bloqueado.
     */
    // kcta opcional — undefined = no tocar esa columna (callers viejos como
    // mba-detail.dialog no lo mandan); JSON.stringify omite las claves con
    // valor undefined, así que no hace falta condicionalizar el objeto acá.
    /** Solo la cuenta EE-RR (KCTA), en cualquier estado del documento. */
    updateCta(id: number, kcta: number | null): Observable<{ ok: boolean }> {
        return this._httpClient.patch<{ ok: boolean }>(`${environment.urlApi}/api/doc/${id}/cta`, { kcta });
    }

    updateConceptoCco(id: number, kfco: number | null, kcco: number | null, kcta?: number | null): Observable<{ ok: boolean }> {
        return this._httpClient.patch<{ ok: boolean }>(
            `${environment.urlApi}/api/doc/${id}/concepto-cco`,
            { kfco, kcco, kcta },
        );
    }

    /**
     * Update doc
     *
     * @param id
     * @param doc
     */
    updateDoc(id: number, doc: any): Observable<DocI> {
        console.log('--> updateDoc');
        delete doc.doc;
        delete doc.neto;
        delete doc.iva;
        delete doc.cli;
        delete doc.prv;
        delete doc.ven;
        delete doc.dctp;
        console.log('doc', doc);
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .patch<DocI>(`${environment.urlApi}/api/doc/` + id, doc)
                    .pipe(
                        map((updatedDoc: any) => {
                            console.log('updatedDoc', updatedDoc);
                            /*  //calcula campos calculables
                    updatedDoc.neto = updatedDoc.suma - updatedDoc.dctm
                    updatedDoc.ivam = Math.round(updatedDoc.neto*19/100)
                    console.log('updatedDoc2', updatedDoc) */

                            try {
                                // Find the index of the updated doc
                                const index = docs.findIndex(
                                    (item) => item.id === id
                                );
                                //console.log('index', index)
                                // Update the doc
                                docs[index] = updatedDoc;

                                // Update the docs
                                this._docs.next(docs);
                            } catch (error) {}

                            // Return the updated doc
                            return updatedDoc;
                        }),
                        switchMap((updatedDoc) =>
                            this.doc$.pipe(
                                take(1),
                                //filter(item => item && item.id === id),
                                tap(() => {
                                    // Update the doc if it's selected
                                    this._doc.next(updatedDoc);

                                    // Return the updated doc
                                    return updatedDoc;
                                })
                            )
                        )
                    )
            )
        );
    }

    /**
     * Delete the doc
     *
     * @param id
     */
    deleteDoc(id: number): Observable<boolean> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .delete(`${environment.urlApi}/api/doc/` + id)
                    .pipe(
                        map((isDeleted: boolean) => {
                            // Find the index of the deleted doc
                            if (docs) {
                                const index = docs.findIndex(
                                    (item) => item.id === id
                                );

                                // Delete the doc
                                docs.splice(index, 1);

                                // Update the docs
                                this._docs.next(docs);
                            }

                            // Return the deleted status
                            return isDeleted;
                        })
                    )
            )
        );
    }

    getDocsByTdocAndCliAndStat(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        tdoc: string = '',
        kcli: number = 0,
        kemp: number = 0,
        ssta: string = `'PENDIENTE','MPAGO','PAGADO'`
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> getDocsByTdocAndCliAndStat()');
        const url =
            `${environment.urlApi}/api/doc/list-tdoc-kcli-ssta/` +
            kemp +
            '/' +
            tdoc +
            '/' +
            kcli +
            '/' +
            ssta;
        console.log('url', url);
        console.log('tdoc: ', tdoc);
        console.log('kcli: ', kcli);
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, {
                params: {
                    page: '' + page,
                    take: '' + take,
                    orderby:
                        orderby.split('.').length === 1
                            ? 'doc.' + orderby
                            : orderby,
                    order,
                    // search,
                },
            })
            .pipe(
                tap((response) => {
                    console.log('getDocsByTypeAndCli>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        page: +response.meta.page - 1,
                        lastPage: response.meta.pageCount,
                        startIndex: 0, //startIndex,
                        endIndex: response.meta.itemCount, //endIndex
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsByTypeAndCliAndPeriod(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        type: string = '',
        kcli: number = 0,
        kemp: number = 0,
        fec0: Date,
        fec1: Date,
        stat: string = '',
        kcco: number[] = []
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        const fmt = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        const url =
            `${environment.urlApi}/api/doc/list-type-cli-period/` +
            type +
            '/' +
            kcli +
            '/' +
            kemp +
            '/' +
            fmt(fec0) +
            '/' +
            fmt(fec1);
        console.log('--> getDocsByTypeAndCliAndPeriod()');
        console.log('url', url);
        console.log('type: ', type);
        console.log('kemp: ', kemp);
        console.log('page: ', page);
        console.log('take: ', take);
        console.log('orderby: ', orderby);
        console.log('order: ', order);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        const params: any = {
            page: '' + page,
            take: '' + take,
            orderby:
                orderby.split('.').length === 1
                    ? 'doc.' + orderby
                    : orderby,
            order,
            search: search,
            stat: stat,
        };
        if (kcco && kcco.length > 0) {
            params.kcco = kcco.join(',');
        }
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, { params })
            .pipe(
                tap((response) => {
                    console.log('getDocsByTypeAndCli>  response:', response);
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsByType(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        type: string = '',
        kemp: number
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        //console.log('getDocs> page,take,orderby,order,search: ', page, take, orderby, order, search);
        //console.log('params> page,take,orderby,order: ', page, take, orderby.split('.').length === 1 ? 'doc.' + orderby : orderby, order);
        console.log(
            'getDocsByType> @',
            `${environment.urlApi}/api/doc/list-type/` + type + `/` + kemp
        );
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/doc/list-type/` + type + `/` + kemp,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'doc.' + orderby
                                : orderby,
                        order: order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    /*  console.log(response);
                 const take = parseInt(response.meta.take, 10);
                 const startIndex = 0;
                 const endIndex = response.data.length - 1; */
                    this._docs.next(response.data);
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        //page: parseInt(response.meta.page, 10),
                        page: +response.meta.page - 1,
                        lastPage: response.meta.pageCount,
                        //startIndex: startIndex,
                        startIndex: 0,
                        //endIndex: endIndex
                        endIndex: response.meta.itemCount,
                    });
                })
            );
    }

    runScrapperWriteDteOnDemand(kemp: number = 0, data: any): Observable<any> {
        const url = `${environment.urlSii}/scrapper/` + kemp;
        return this._httpClient.post(url, data);
    }

    runScrapperOpenSiiOnDemand(kemp: number = 0, data: any): Observable<any> {
        console.log('---> runScrapperOpenSiiOnDemand()');
        console.log('kemp', kemp);
        console.log('data', data);
        const url = `https://prp.api.amazingia.cl:8004/scrapper/` + kemp;
        return this._httpClient.post(url, data);
    }

    runScrapperNewsDteOnDemand(kemp: number = 0, data: any): Observable<any> {
        console.log('---> runScrapperNewsDteOnDemand()');
        console.log('kemp', kemp);
        console.log('data', data);
        const url = `${environment.urlSii}/emitter/`;
        return this._httpClient.post(url, data);
    }

    getDocsByTypeAndTerAndPeriod(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        type: string = '',
        kter: number = 0,
        kemp: number = 0,
        fec0: Date,
        fec1: Date,
        kcco: number[] = [],
        // Default true (sin filtrar) para no cambiar el comportamiento de
        // otros llamadores de este método compartido (p.ej. caj/din) — solo
        // caj/deg pasa explícitamente `false` por defecto (checkbox propio).
        incluirCargo: boolean = true,
        // Rango de fecha estimada de pago (DOC.FEPA) 'YYYY-MM-DD' — caj/deg. null = sin límite.
        fepa0: string | null = null,
        fepa1: string | null = null,
        // "Cuenta EE-RR" — caj/din: 'SI' = solo con DOC.KCTA, 'NO' = solo sin, null = todos.
        conCta: 'SI' | 'NO' | null = null,
        // caj/deg: filtros específicos (además de `search` general).
        filtros: { nume?: string; stat?: string[]; deta?: string } = {},
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        const fmt = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        const url =
            `${environment.urlApi}/api/doc/list-type-ter-period/` +
            type + '/' + kter + '/' + kemp + '/' + fmt(fec0) + '/' + fmt(fec1);
        const params: any = {
            page: '' + page,
            take: '' + take,
            orderby: orderby.split('.').length === 1 ? 'doc.' + orderby : orderby,
            order,
            search: search,
            incluirCargo: incluirCargo ? 'true' : 'false',
        };
        if (kcco && kcco.length > 0) {
            params.kcco = kcco.join(',');
        }
        if (fepa0) params.fepa0 = fepa0;
        if (fepa1) params.fepa1 = fepa1;
        // El backend recibe sinCta=NO/SI (invertido respecto de conCta).
        if (conCta === 'SI') params.sinCta = 'NO';
        if (conCta === 'NO') params.sinCta = 'SI';
        if (filtros.nume) params.fnume = filtros.nume;
        if (filtros.stat?.length) params.stat = filtros.stat.join(',');
        if (filtros.deta) params.deta = filtros.deta;
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, { params })
            .pipe(
                tap((response) => {
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex: (+response.meta.page - 1) * +response.meta.take,
                        endIndex: (+response.meta.page - 1) * +response.meta.take + +response.meta.take,
                    });
                    this._docs.next(response.data);
                })
            );
    }

    getDocsByTypeAndPrvAndPeriod(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        type: string = '',
        kprv: number = 0,
        kemp: number = 0,
        fec0: Date,
        fec1: Date,
        kcco: number[] = [],
        stat: string[] = [],
        // Solo NCP (cmp/ncp): 'ASIGNADO'/'NO_ASIGNADO' — ver
        // DocService.listByTypeAndPrvAndPeriod() (backend).
        asignado: string[] = [],
        prvKfco: number[] = [],
        // Monto total exacto (ABS(TOTA)) — cmp/fap. null = sin filtro.
        tota: number | null = null,
        // Rango de fecha estimada de pago (DOC.FEPA) 'YYYY-MM-DD' — cmp/fap. null = sin límite.
        fepa0: string | null = null,
        fepa1: string | null = null,
        // "Cuenta EE-RR" — cmp/fap: 'SI' = solo con cuenta del Estado de Resultados,
        // 'NO' = solo sin cuenta (DOC.KCTA vacío), null = todos.
        conCta: 'SI' | 'NO' | null = null,
    ): Observable<ListadoDoc> {
        const url =
            `${environment.urlApi}/api/doc/list-type-prv-period/` +
            type +
            '/' +
            kprv +
            '/' +
            kemp +
            '/' +
            fec0 +
            '/' +
            fec1;
        console.log('--> getDocsByTypeAndPrvAndPeriod()');
        console.log('url', url);
        console.log('kemp: ', kemp);
        console.log('page: ', page);
        console.log('take: ', take);
        console.log('orderby: ', orderby);
        console.log('order: ', order);
        const params: any = {
            page: '' + page,
            take: '' + take,
            orderby:
                orderby.split('.').length === 1
                    ? 'doc.' + orderby
                    : orderby,
            order,
            search: search,
        };
        if (kcco && kcco.length > 0) {
            params.kcco = kcco.join(',');
        }
        if (stat && stat.length > 0) {
            params.stat = stat.join(',');
        }
        if (asignado && asignado.length > 0) {
            params.asignado = asignado.join(',');
        }
        if (prvKfco.length > 0) {
            params.prvKfco = prvKfco.join(',');
        }
        if (tota != null && tota > 0) {
            params.tota = String(tota);
        }
        if (fepa0) params.fepa0 = fepa0;
        if (fepa1) params.fepa1 = fepa1;
        // El backend recibe sinCta=NO/SI (invertido respecto de conCta).
        if (conCta === 'SI') params.sinCta = 'NO';
        if (conCta === 'NO') params.sinCta = 'SI';
        return this._httpClient
            .get<ListadoDoc>(url, { params })
            .pipe(
                tap((response) => {
                    console.log(
                        'getDocsByTypeAndPrvAndPeriod>  response:',
                        response
                    );
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._docs.next(response.data);
                })
            );
    }

    docsByModAndPeriod(
        kemp: number = 0,
        modu: string = '',
        fec0: Date,
        fec1: Date
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> docsByModAndPeriod()');
        const url =
            `doc/list-mod-period/` +
            kemp +
            '/' +
            modu +
            '/' +
            moment(fec0).format('YYYY-MM-DD') +
            '/' +
            moment(fec1).format('YYYY-MM-DD');
        console.log('url:', url);
        console.log('kemp:', kemp);
        console.log('modu:', modu);
        console.log('fec0:', fec0);
        console.log('fec1:', fec1);

        // Oracle limita los IN-list a 1000 elementos, y el JOIN paginado de TypeORM
        // (leftJoinAndSelect + skip/take) arma uno de ese tamaño para hidratar entidades.
        // Por eso NO se puede pedir un take > 1000 en una sola pasada: se pagina de a
        // 1000 y se concatenan las páginas acá en el frontend.
        const pageSize = 1000;
        const fetchPage = (page: number) =>
            this._httpClient.get<{ meta: PaginationApi; data: DocI[] }>(
                `${environment.urlApi}/api/` + url,
                {
                    params: {
                        page: '' + page,
                        take: '' + pageSize,
                        orderby: 'frec',
                    },
                }
            );

        return fetchPage(1).pipe(
            expand((response) => {
                const fetchedSoFar = +response.meta.page * pageSize;
                return response.data.length === pageSize &&
                    fetchedSoFar < response.meta.itemCount
                    ? fetchPage(+response.meta.page + 1)
                    : EMPTY;
            }),
            reduce(
                (acc, response) => ({
                    meta: response.meta,
                    data: [...acc.data, ...response.data]
                }),
                { meta: null as PaginationApi, data: [] as DocI[] }
            ),
            tap((merged) => {
                console.log('docsByModAndPeriod> merged:', merged);
                this._pagination.next({
                    length: merged.meta.itemCount,
                    size: pageSize,
                    page: 0,
                    lastPage: merged.meta.pageCount,
                    startIndex: 0,
                    endIndex: merged.meta.itemCount,
                });
                this._docs.next(merged.data);
            })
        );
    }

    getDocsByTypeAndPrv(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        type: string = '',
        kprv: number = 0,
        kemp: number = 0
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> getDocsByTypeAndPrv()');
        const api =
            `${environment.urlApi}/api/doc/list-type-prv-period/` +
            type +
            '/' +
            kprv +
            '/' +
            kemp;
        console.log('api', api);
        console.log('orderby: ', orderby);
        console.log('kemp: ', kemp);
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(api, {
                params: {
                    page: '' + page,
                    take: '' + take,
                    orderby:
                        orderby.split('.').length === 1
                            ? 'doc.' + orderby
                            : orderby,
                    order,
                    // search,
                },
            })
            .pipe(
                tap((response) => {
                    console.log('getDocsByTypeAndCli>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        page: +response.meta.page - 1,
                        lastPage: response.meta.pageCount,
                        startIndex: 0, //startIndex,
                        endIndex: response.meta.itemCount, //endIndex
                    });
                    this._docs.next(response.data);
                })
            );
    }

    findDocForDialog(
        kemp: number = 0,
        tdoc: string = '',
        kent: number = 0,
        search: string = ''
    ): Observable<DocI[]> {
        console.log('--> findDocForDialog()');
        const api =
            `${environment.urlApi}/api/doc/find-all-by-search/` +
            kemp +
            `/` +
            tdoc +
            `/` +
            kent +
            `/` +
            search;
        console.log('api', api);
        console.log('kemp: ', kemp);
        return this._httpClient.get<DocI[]>(api).pipe(
            tap((response) => {
                console.log('findDocForDialog>  response:', response);
                this._docs.next(response);
            })
        );
    }

    vtaByDay(kemp: number = 0, fec0: string, fec1: string): Observable<Data> {
        console.log('--> vtaByDay()');
        const api =
            `${environment.urlApi}/api/vta03/vta-by-day/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('vtaByDay>  response:', response);
            })
        );
    }

    cmpByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cmpByDay()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const f1 = moment(fec1).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/cmp02/cmp-by-day/` +
            kemp +
            `/` +
            f0 +
            `/` +
            f1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cmpByDay>  response:', response);
            })
        );
    }

    taxByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        const f0 = moment(fec0).format('YYYY-MM-DD'); //new Date(fec0)
        const f1 = moment(fec1).format('YYYY-MM-DD'); //new Date(fec0)
        console.log('--> taxByDay()');
        const api =
            `${environment.urlApi}/api/doc01/tax-by-day/` +
            kemp +
            `/` +
            f0 +
            `/` +
            f1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('f0: ', f0);
        console.log('f1: ', f1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cmpByDay>  response:', response);
            })
        );
    }

    cxcByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxcByDay()');
        const api =
            `${environment.urlApi}/api/doc02/cxc-by-day/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cmpByDay>  response:', response);
            })
        );
    }

    cxcByDayVtas(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxcByDayVtas()');
        const api =
            `${environment.urlApi}/api/vta02v/vta-by-day/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxcByDayVtas>  response:', response);
            })
        );
    }

    cxpCmpByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxpCmpByDay()');
        const api =
            `${environment.urlApi}/api/cxp-cmp-by-day/` +
            kemp +
            `/` +
            moment(fec0).format('YYYY-MM-DD') +
            `/` +
            moment(fec1).format('YYYY-MM-DD');
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxpCmpByDay>  response:', response);
            })
        );
    }

    cxpAnuByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxpAnuByDay()');
        const api =
            `${environment.urlApi}/api/cxp-anu-by-day/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxpAnuByDay>  response:', response);
            })
        );
    }

    cxpPayByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxpPayByDay()');
        const api =
            `${environment.urlApi}/api/cxp-pay-by-day/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxpPayByDay>  response:', response);
            })
        );
    }

    cxpSaldToDay(kemp: number = 0, fec0: Date): Observable<number> {
        console.log('--> cxpSaldToDay()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/cxp-sld/to-day/` + kemp + `/` + f0;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        return this._httpClient.get<number>(api).pipe(
            tap((response) => {
                console.log('cxpSaldToDay>  response:', response);
            })
        );
    }

    cxpSaldByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxpSaldByDay()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const f1 = moment(fec1).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/cxp-sld/by-day/` +
            kemp +
            `/` +
            f0 +
            `/` +
            f1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxpSaldByDay>  response:', response);
            })
        );
    }

    cxpAcumByMonth(
        kemp: number = 0,
        ym0: string,
        ym1: string
    ): Observable<any> {
        console.log('--> cxpAcumByMonth()');
        const api =
            `${environment.urlApi}/api/cxp-acu-by-month/` +
            kemp +
            `/` +
            ym0 +
            `/` +
            ym1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('ym0: ', ym0);
        console.log('ym1: ', ym1);
        return this._httpClient.get<any>(api).pipe(
            tap((response) => {
                console.log('cxpAcumByMonth>  response:', response);
            })
        );
    }

    cxcAcumByMonth(
        kemp: number = 0,
        ym0: string,
        ym1: string
    ): Observable<any> {
        console.log('--> cxcAcumByMonth()');
        const api =
            `${environment.urlApi}/api/cxc-acu-by-month/` +
            kemp +
            `/` +
            ym0 +
            `/` +
            ym1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('ym0: ', ym0);
        console.log('ym1: ', ym1);
        return this._httpClient.get<any>(api).pipe(
            tap((response) => {
                console.log('cxcAcumByMonth>  response:', response);
            })
        );
    }

    cxcByDayAnus(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxcByDayAnus()');
        const api =
            `${environment.urlApi}/api/vta02a/vta-by-day/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxcByDayVtas>  response:', response);
            })
        );
    }

    cxcByDayPays(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxcByDayPays()');
        const api =
            `${environment.urlApi}/api/vta02p/pays-by-day/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxcByDayVtas>  response:', response);
            })
        );
    }

    cxcByDaySald(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxcByDaySald()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const f1 = moment(fec1).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/vta02s/sald-by-day/` +
            kemp +
            `/` +
            f0 +
            `/` +
            f1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxcByDaySald>  response:', response);
            })
        );
    }

    cxcSaldByMonth(
        kemp: number = 0,
        fec0: string,
        fec1: string
    ): Observable<any> {
        console.log('--> cxcSaldByMonth()');
        const api =
            `${environment.urlApi}/api/v_cxc_sald_mes/sald-by-month/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<any>(api).pipe(
            tap((response) => {
                console.log('cxcSaldByMonth>  response:', response);
            })
        );
    }

    // lee saldo al inicio de fecha dada
    cxcSaldToDay(kemp: number = 0, fec0: Date): Observable<number> {
        console.log('--> cxcSaldToDay()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/vta02s/sald-to-day/` + kemp + `/` + f0;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        return this._httpClient.get<number>(api).pipe(
            tap((response) => {
                console.log('cxcSaldToDay>  response:', response);
            })
        );
    }

    cxpByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> cxpByDay()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const f1 = moment(fec1).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/doc03/cxp-by-day/` +
            kemp +
            `/` +
            f0 +
            `/` +
            f1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cxpByDay>  response:', response);
            })
        );
    }

    sbaByDay(kemp: number = 0, fec0: Date, fec1: Date): Observable<Data> {
        console.log('--> sbaByDay()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const f1 = moment(fec1).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/doc04/sba-by-day/` +
            kemp +
            `/` +
            f0 +
            `/` +
            f1;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        console.log('fec1: ', fec1);
        return this._httpClient.get<Data>(api).pipe(
            tap((response) => {
                console.log('cmpByDay>  response:', response);
            })
        );
    }

    sbaInDay(kemp: number = 0, fec0: Date): Observable<any> {
        console.log('--> sbaInDay()');
        const f0 = moment(fec0).format('YYYY-MM-DD');
        const api =
            `${environment.urlApi}/api/doc04/sba-in-day/` + kemp + `/` + f0;
        console.log('api', api);
        console.log('kemp: ', kemp);
        console.log('fec0: ', fec0);
        return this._httpClient.get<any>(api).pipe(
            tap((response) => {
                console.log('sbaInDay>  response:', response);
            })
        );
    }

    saldoMesAnteriorFlujo(kemp: number = 0): Observable<{ sald: number }> {
        const api = `${environment.urlApi}/api/doc04/saldo-mes-anterior-flujo/` + kemp;
        return this._httpClient.get<{ sald: number }>(api);
    }

    // Dashboard ger/dbg (primera pantalla tras el login): 4 requests, uno por
    // grupo de tarjetas, en vez de las ~13 peticiones sueltas de antes
    // (vta03/cmp02/doc01/vta02s/cxp-sld/doc04/fin/rcv02/rcv). Cada backend
    // corre solo las queries Oracle de su propio grupo, en paralelo
    // internamente vía Promise.all (ver dbg.service.ts backend).
    //
    // Separado en 4 llamadas (no 1 combinada) a propósito: DbgSummaryCacheService
    // cachea cada grupo por separado con su propia invalidación (RCV/cobro/
    // pago/cartola), y con un solo endpoint combinado invalidar cualquiera de
    // esos 4 eventos forzaba recalcular los otros 3 también.
    dbgSummaryRcv(kemp: number, fromDate: string, toDate: string): Observable<any> {
        const api =
            `${environment.urlApi}/api/dbg/summary-rcv/` + kemp + `/` + fromDate + `/` + toDate;
        return this._httpClient.get<any>(api);
    }

    dbgSummaryCxc(kemp: number, fromDate: string, toDate: string): Observable<any> {
        const api =
            `${environment.urlApi}/api/dbg/summary-cxc/` + kemp + `/` + fromDate + `/` + toDate;
        return this._httpClient.get<any>(api);
    }

    dbgSummaryCxp(kemp: number, fromDate: string, toDate: string): Observable<any> {
        const api =
            `${environment.urlApi}/api/dbg/summary-cxp/` + kemp + `/` + fromDate + `/` + toDate;
        return this._httpClient.get<any>(api);
    }

    dbgSummaryBancos(kemp: number, fromDate: string, toDate: string): Observable<any> {
        const api =
            `${environment.urlApi}/api/dbg/summary-bancos/` + kemp + `/` + fromDate + `/` + toDate;
        return this._httpClient.get<any>(api);
    }

    getDocsPendingByPrv(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kprv: number = 0,
        tdoc: string = ''
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> getDocsPendingByPrv()');
        const url = `${environment.urlApi}/api/doc/listPendingByPrv/` + kprv;
        console.log('url', url);
        console.log('kprv: ', kprv);
        const params: any = {
            page: '' + page,
            take: '' + take,
            orderby:
                orderby.split('.').length === 1
                    ? 'doc.' + orderby
                    : orderby,
            order,
            // search,
        };
        if (tdoc) params.tdoc = tdoc; // 'BHE' -> "Pagar a Emisores" (/hon/pae)
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, {
                params,
            })
            .pipe(
                tap((response) => {
                    console.log('response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._docs.next(response.data);
                })
            );
    }

    findDoc(kdoc): Observable<DocI> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get<DocI>(`${environment.urlApi}/api/doc/` + kdoc)
                    .pipe(
                        map((doc) => {
                            //                    console.log('foundDoc', doc)
                            return doc;
                        })
                    )
            )
        );
    }

    getDocsByTdocAndPrvAndStat(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nume',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        tdoc: string = '',
        kprv: number = 0,
        kemp: number = 0,
        ssta: string = `'PENDIENTE','MPAGO','PAGADO'`
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> getDocsByTdocAndPrvAndStat()');
        const url =
            `${environment.urlApi}/api/doc/list-tdoc-kprv-ssta/` +
            kemp +
            '/' +
            tdoc +
            '/' +
            kprv +
            '/' +
            ssta;
        console.log('url', url);
        console.log('tdoc: ', tdoc);
        console.log('kprv: ', kprv);
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, {
                params: {
                    page: '' + page,
                    take: '' + take,
                    orderby:
                        orderby.split('.').length === 1
                            ? 'doc.' + orderby
                            : orderby,
                    order,
                    // search,
                },
            })
            .pipe(
                tap((response) => {
                    console.log('getDocsByTypeAndCli>  response:', response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: take,
                        page: +response.meta.page - 1,
                        lastPage: response.meta.pageCount,
                        startIndex: 0, //startIndex,
                        endIndex: response.meta.itemCount, //endIndex
                    });
                    this._docs.next(response.data);
                })
            );
    }

    clear(kemp, tdoc): Observable<boolean> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get(
                        `${environment.urlApi}/api/doc/clear/` +
                            kemp +
                            `/` +
                            tdoc
                    )
                    .pipe(
                        map((isDeleted: boolean) => {
                            return isDeleted;
                        })
                    )
            )
        );
    }

    /**
     * Cuenta documentos de un proveedor (opcionalmente acotado por tdoc).
     * Usado por el modal de Emisores (/hon/emi) para bloquear el borrado si el
     * emisor ya tiene BHE cargadas. No toca ningún BehaviorSubject.
     */
    countDocsByPrv(kemp: number, kprv: number, tdoc?: string): Observable<number> {
        let url = `${environment.urlApi}/api/doc/count-by-prv/${kemp}/${kprv}`;
        if (tdoc) url += `?tdoc=${tdoc}`;
        return this._httpClient
            .get<{ count: number }>(url)
            .pipe(map((r) => r?.count ?? 0));
    }

    copyDoc(doc, docdets): Observable<DocI> {
        const data = {
            doc: doc,
            docdets: docdets,
        };
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .post<DocI>(`${environment.urlApi}/api/doc/copy/`, data)
                    .pipe(
                        map((newDoc) => {
                            // Update the docs with the new doc
                            this._docs.next([newDoc, ...docs]);

                            // Return the new doc
                            return newDoc;
                        })
                    )
            )
        );
    }

    copyDocUf(doc, docdets, uf): Observable<DocI> {
        const data = {
            doc: doc,
            docdets: docdets,
            uf: uf,
        };
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .post<DocI>(`${environment.urlApi}/api/doc/copy-uf/`, data)
                    .pipe(
                        map((newDoc) => {
                            // Update the docs with the new doc
                            this._docs.next([newDoc, ...docs]);

                            // Return the new doc
                            return newDoc;
                        })
                    )
            )
        );
    }

    firtMonthCmp(kemp): Observable<any> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get<DocI>(
                        `${environment.urlApi}/api/doc/limitOperDate/` +
                            kemp +
                            '/min/cmp'
                    )
                    .pipe(
                        map((doc) => {
                            //                    console.log('foundDoc', doc)
                            return doc;
                        })
                    )
            )
        );
    }

    lastMonthCmp(kemp): Observable<any> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get<DocI>(
                        `${environment.urlApi}/api/doc/limitOperDate/` +
                            kemp +
                            '/max/cmp'
                    )
                    .pipe(
                        map((doc) => {
                            //                    console.log('foundDoc', doc)
                            return doc;
                        })
                    )
            )
        );
    }

    firtMonthVta(kemp): Observable<any> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get<DocI>(
                        `${environment.urlApi}/api/doc/limitOperDate/` +
                            kemp +
                            '/min/vta'
                    )
                    .pipe(
                        map((doc) => {
                            //                    console.log('foundDoc', doc)
                            return doc;
                        })
                    )
            )
        );
    }

    lastMonthVta(kemp): Observable<any> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get<DocI>(
                        `${environment.urlApi}/api/doc/limitOperDate/` +
                            kemp +
                            '/max/vta'
                    )
                    .pipe(
                        map((doc) => {
                            //                    console.log('foundDoc', doc)
                            return doc;
                        })
                    )
            )
        );
    }

    findVtaDoc(kemp, tdoc, nume): Observable<any> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get<DocI>(
                        `${environment.urlApi}/api/doc/findVtaDoc/` +
                            kemp +
                            '/' +
                            tdoc +
                            '/' +
                            nume
                    )
                    .pipe(
                        map((doc) => {
                            return doc;
                        })
                    )
            )
        );
    }

    // Busca doc de compra por tdoc+nref+rutr (folio del proveedor, no el correlativo interno).
    findCmpDoc(kemp, tdoc, nref, rutr): Observable<any> {
        return this._httpClient.get<DocI[]>(
            `${environment.urlApi}/api/doc/findCmpDoc/${kemp}/${tdoc}/${nref}/${rutr}`
        );
    }

    // Método para buscar el documento
    findDoc2(oper, doc): Observable<DocI> {
        console.log('--> findDoc2()', doc);
        //const rutr =  doc.rutr
        // console.log('rutr', rutr)
        //console.log('doc.rutr.split("-")[0]', doc.rutr.split("-")[0])
        let url = '';

        if (oper === 'VTA') {
            url = `${environment.urlApi}/api/doc/findVtaDoc/${doc.kemp}/${doc.tdoc}/${doc.nume}`;
        } else {
            url = `${environment.urlApi}/api/doc/findCmpDoc/${doc.kemp}/${doc.tdoc}/${doc.nref}/${doc.rutr}`;
        }
        console.log('url', url);
        return this._httpClient.get<DocI>(url).pipe(
            tap((doc) => console.log('Documento encontrado:', doc)), // Muestra el documento en la consola
            catchError((error) => {
                console.error('Error al encontrar el documento:', error);
                return throwError(() => new Error('Documento no encontrado'));
            })
        );
    }

    // Método para editar el documento una vez encontrado
    editDoc(
        oper,
        //docData: Partial<DocI>
        docData: any
    ): Observable<DocI> {
        console.log('--> editDoc()', docData);
        //docData.femi = new Date(docData.femi);
        //docData.frec = new Date(docData.frec);
        //docData.femi = new Date(docData.femi);
        //docData.freemi = new Date(docData.femi);
        return this.findDoc2(oper, docData).pipe(
            tap((doc) => console.log('doc encontrado:', doc)),
            switchMap((doc) =>
                this._httpClient.patch<DocI>(
                    `${environment.urlApi}/api/doc/` + doc[0].id,
                    docData
                )
            ),
            map((response) => {
                console.log('Documento actualizado:', response);
                return response;
            }),
            catchError((error) => {
                console.error('Error al actualizar el documento:', error);
                return throwError(
                    () => new Error('Error al actualizar el documento')
                );
            })
        );
    }

    waitForStatusChange(
        documentId: number,
        maxAttempts: number = 60
    ): Observable<any> {
        return interval(1000).pipe(
            switchMap(() => this.findDoc(documentId)),
            map((response) => {
                if (response.stat === 'IMPAGO') {
                    return response;
                }
                throw new Error('NotReadyYet');
            }),
            first(),
            catchError((error, caught) => {
                if (error.message === 'NotReadyYet') {
                    return caught;
                }
                return throwError(() => error);
            }),
            takeWhile((_, index) => index < maxAttempts, true)
        );
    }

    listByTypeStat(
        kemp: number = 0,
        tdoc: string = '',
        stat: string = `'PENDIENTE','MPAGO','PAGADO'`
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> listByTypeStat()');
        const url =
            `${environment.urlApi}/api/doc/list-type-stat/` +
            kemp +
            '/' +
            tdoc +
            '/' +
            stat;
        console.log('url', url);
        console.log('kemp: ', kemp);
        console.log('tdoc: ', tdoc);
        console.log('stat: ', stat);
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, {
                params: {
                    page: '' + 1,
                    take: '' + 100,
                },
            })
            .pipe(
                tap((response) => {
                    console.log('listByTypeStat>  response:', response);
                })
            );
    }

    updateToSend(
        kemp: number = 0,
        tdoc: string = ''
    ): Observable<{ meta: PaginationApi; data: DocI[] }> {
        console.log('--> listByTypeStat()');
        const url =
            `${environment.urlApi}/api/doc/update-to-send/` + kemp + '/' + tdoc;
        console.log('url', url);
        console.log('kemp: ', kemp);
        console.log('tdoc: ', tdoc);
        return this._httpClient
            .get<{ meta: PaginationApi; data: DocI[] }>(url, {
                params: {
                    page: '' + 1,
                    take: '' + 100,
                },
            })
            .pipe(
                tap((response) => {
                    console.log('updateToSend>  response:', response);
                })
            );
    }

    annulDoc(id: number): Observable<boolean> {
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .get(`${environment.urlApi}/api/doc/annul/` + id)
                    .pipe(
                        map((isDeleted: boolean) => {
                            // Find the index of the deleted doc
                            if (docs) {
                                const index = docs.findIndex(
                                    (item) => item.id === id
                                );

                                // Delete the doc
                                docs.splice(index, 1);

                                // Update the docs
                                this._docs.next(docs);
                            }

                            // Return the deleted status
                            return isDeleted;
                        })
                    )
            )
        );
    }

    simule(data): Observable<DocI> {
        console.log('---> simule()')
        console.log('data', data)
        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .post<DocI>(`${environment.urlApi}/api/doc/simule`, data)
                    .pipe(
                        map((newDoc) => {
                            // Update the docs with the new doc
                            this._docs.next([newDoc, ...docs]);

                            // Return the new doc
                            return newDoc;
                        })
                    )
            )
        );
    }

    // ── GET doc por ID directo al API (sin caché BehaviorSubject) ──────────
    getDocHttp(kdoc: number): Observable<DocI> {
        return this._httpClient.get<DocI>(`${environment.urlApi}/api/doc/${kdoc}`);
    }

    // ── Saneamiento/reproceso de NCP históricas (FAP/FEP) ───────────────────
    // Fase 1 — SOLO LECTURA, no modifica nada. Conveniencia para disparar el
    // dry-run desde la consola del navegador (o una UI futura) sin tener que
    // armar la URL a mano: this._docService.dryRunNcpReproceso(kemp).subscribe(...)
    dryRunNcpReproceso(kemp: number): Observable<any> {
        return this._httpClient.get<any>(`${environment.urlApi}/api/ncp-reproceso/dry-run/${kemp}`);
    }

    // Fase 2 — EJECUCIÓN REAL (borra NCP, llama al scraper, reimporta,
    // recalcula). NO llamar sin autorización explícita — ver
    // ncp-reproceso.service.ts para el detalle completo del proceso.
    ejecutarNcpReproceso(kemp: number): Observable<any> {
        return this._httpClient.post<any>(`${environment.urlApi}/api/ncp-reproceso/ejecutar/${kemp}`, {});
    }

    // Recálculo determinístico de facturas FAP/FEP por período RCV (año-mes
    // de recepción) — se llama al terminar con éxito el importador normal
    // de /sii/rcv ("Importar registros desde el SII"), para que una factura
    // con varias NCP del mismo período quede correcta de inmediato (ver
    // DocumentoSaldoService.recalcularFacturasPorNcpPeriodo en el backend).
    recalcularNcpPeriodo(kemp: number, anio: number, mes: number): Observable<any> {
        const periodo = `${anio}-${String(mes).padStart(2, '0')}`;
        return this._httpClient.post<any>(`${environment.urlApi}/api/doc/recalcular-ncp-periodo/${kemp}/${periodo}`, {});
    }

    // ── Pagos recibidos por documento ──────────────────────────────────────
    // composicion/ncps son opcionales en la respuesta (EFA usa este mismo
    // endpoint y su popup no los consume).
    getPagosByDoc(kdoc: number, kemp: number): Observable<{ pagos: any[]; composicion?: ComposicionDocumento; ncps?: NcpRelacionada[] }> {
        return this._httpClient.get<{ pagos: any[]; composicion?: ComposicionDocumento; ncps?: NcpRelacionada[] }>(
            `${environment.urlApi}/api/doc/pagos/${kdoc}/${kemp}`
        );
    }

    // Versión batch: trae los pagos de varios documentos en una sola petición
    // (WHERE KDOC IN (...) en el backend) en vez de una por documento.
    getPagosByDocsBatch(
        kdocs: number[],
        kemp: number
    ): Observable<Record<number, any[]>> {
        return this._httpClient.post<Record<number, any[]>>(
            `${environment.urlApi}/api/doc/pagos-batch/${kemp}`,
            { kdocs }
        );
    }

    normalizarPagosDoc(kdoc: number, kemp: number): Observable<{ ok: boolean; mensaje: string; creados?: any[] }> {
        return this._httpClient.get<{ ok: boolean; mensaje: string; creados?: any[] }>(
            `${environment.urlApi}/api/doc/normalizar-pagos/${kdoc}/${kemp}`
        );
    }

    /** fin/edr: una sola llamada para todas las "reglas por cuenta" que la
     *  pantalla necesite (reemplaza los 5 métodos separados que había antes:
     *  ventaNetaPorCta, costoVentaPorCta, gastosRrhhPorCta,
     *  serviciosDeTercerosPorCta, arriendoEInstalacionesPorCta). Cada regla
     *  dice qué tipos de documento sumar (`tdocs`, null = todo DOC) y con qué
     *  columna ('SUMA'|'TOTA'|'AUTO' = SUMA si la tiene, si no TOTA).
     *  Devuelve { [regla.id]: { [kcta]: number[12] } } (índice 0 = enero). */
    porCtaBatch(
        kemp: number,
        anio: number,
        reglas: { id: string; tdocs: string[] | null; columna: 'SUMA' | 'TOTA' | 'AUTO' }[]
    ): Observable<Record<string, Record<number, number[]>>> {
        return this._httpClient.post<Record<string, Record<number, number[]>>>(
            `${environment.urlApi}/api/doc/por-cta-batch/${kemp}/${anio}`,
            { reglas }
        );
    }

    /** fin/edr: drill-down al hacer click en una celda — los documentos que
     *  componen su suma, con la MISMA regla (tdocs/columna) que armó la celda
     *  (ver porCtaBatch). `mes` es 1-12. */
    documentosPorCta(
        kemp: number,
        anio: number,
        mes: number,
        kcta: number,
        tdocs: string[] | null,
        columna: 'SUMA' | 'TOTA' | 'AUTO'
    ): Observable<DocPorCtaDetalle[]> {
        return this._httpClient.post<DocPorCtaDetalle[]>(
            `${environment.urlApi}/api/doc/documentos-por-cta/${kemp}/${anio}/${mes}/${kcta}`,
            { tdocs, columna }
        );
    }

    /** Totalizador de listado sensible a filtros (cliente, período, búsqueda) —
     *  ver DocService.resumenPorTipoClientePeriodo en el backend para por qué
     *  no se reusa el endpoint compartido /v01/resume (Vta01Service.resumeVta01). */
    resumenPorTipoClientePeriodo(
        tdoc: string,
        kcli: number,
        kemp: number,
        fec0: Date,
        fec1: Date,
        search?: string
    ): Observable<{ cant: number; suma: number; dctm: number; ivam: number; tota: number; abon: number }> {
        const fmt = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        const url = `${environment.urlApi}/api/doc/resumen-por-tipo-cliente-periodo/${tdoc}/${kcli}/${kemp}/${fmt(fec0)}/${fmt(fec1)}`;
        const params: any = {};
        if (search && search.trim() !== '') params.search = search.trim();
        return this._httpClient.get<{ cant: number; suma: number; dctm: number; ivam: number; tota: number; abon: number }>(url, { params });
    }

    eliminarDocpagHuerfano(kdocpag: number, kdoc: number, kemp: number): Observable<{ ok: boolean; mensaje: string }> {
        return this._httpClient.delete<{ ok: boolean; mensaje: string }>(
            `${environment.urlApi}/api/doc/docpag-huerfano/${kdocpag}/${kdoc}/${kemp}`
        );
    }

    desasignarDocpag(kdocpag: number, kdoc: number, kemp: number): Observable<{ ok: boolean; mensaje: string; kpag?: number; nuevoAsig?: number; docStat?: string }> {
        return this._httpClient.delete<{ ok: boolean; mensaje: string; kpag?: number; nuevoAsig?: number; docStat?: string }>(
            `${environment.urlApi}/api/doc/desasignar-docpag/${kdocpag}/${kdoc}/${kemp}`
        );
    }

   /*  simuleDetail(nume, fech): Observable<DocI> {

        return this.docs$.pipe(
            take(1),
            switchMap((docs) =>
                this._httpClient
                    .post<DocI>(`${environment.urlApi}/api/doc/copy/`, data)
                    .pipe(
                        map((newDoc) => {
                            // Update the docs with the new doc
                            this._docs.next([newDoc, ...docs]);

                            // Return the new doc
                            return newDoc;
                        })
                    )
            )
        );
    } */

    syncFev(id: number): Observable<{ ok: boolean; creado: boolean; actualizado: boolean; id?: number; message: string }> {
        return this._httpClient.post<any>(`${environment.urlApi}/api/doc/${id}/sync-fev`, {});
    }

    // -----------------------------------------------------------------------------------------------------
    // ODS (Órdenes de Servicio) generadas desde Contratos (tdoc='CON') — ver
    // ofv/ods.component. Backend ya expone estos endpoints (doc.controller.ts).
    // -----------------------------------------------------------------------------------------------------

    /** Clientes con contrato de arriendo vigente que aún no tienen ODS este mes. */
    getServiceOrdersCandidates(kemp: number): Observable<any[]> {
        return this._httpClient.get<any[]>(`${environment.urlApi}/api/doc/get-cli-list-without-ods/${kemp}`);
    }

    /**
     * Genera una ODS por cada cliente/contrato seleccionado. `selected` son
     * filas devueltas por getServiceOrdersCandidates ({id, name, rutt, kdoc}
     * — `kdoc` es el ID real del DOC tdoc='CON'); el backend
     * (generateServiceOrdersSelected) espera `contractIds: number[]`, no el
     * array de clientes tal cual.
     */
    generateServiceOrdersFromSelected(kemp: number, selected: any[]): Observable<any[]> {
        const contractIds = selected.map((s) => s.kdoc).filter((id) => !!id);
        return this._httpClient.post<any[]>(
            `${environment.urlApi}/api/doc/generate-from-selected-contracts/${kemp}/selected`,
            { kemp, contractIds }
        );
    }
}
